module.exports = __webpack_public_path__ + "assets/RetinaNarr-Thin.ea02f670ef4a0960a7291c487c26bc7d.woff";